import * as React from "react";
import { PageHeader, Button } from "antd";
import bankLogo from "../assets/images/bank-logo.png";
import LanguagePicker from "./settings/LanguagePicker";
import { LogoutOutlined } from "@ant-design/icons";

const Header = ({
  title,
  buttonTitle,
  buttonClick,
  languagePickerVisible,
  onLanguageChange,
  language
}: {
  title?: string;
  languagePickerVisible: boolean;
  buttonTitle?: string;
  buttonClick?: any;
  onLanguageChange?: any;
  language?: string;
}) => {
  return (
    <PageHeader
      className="header-wrapper"
      title={title}
      avatar={{
        className: "header-avatar",
        src: bankLogo,
        shape: "square",
        size: "large",
        alt: "bank-logo"
      }}
      extra={[
        <LanguagePicker
          visible={languagePickerVisible}
          onLanguageChange={onLanguageChange}
          language={language}
          key="header-language-picker"
        />,
        <Button
          key="header-btn"
          onClick={buttonClick}
          icon={<LogoutOutlined />}
          className="header-wrapper-button"
          style={{ display: !buttonTitle ? "none" : "initial" }}
        >
          {buttonTitle}
        </Button>
      ]}
    />
  );
};

export default Header;
